const navigation = document.querySelector('.ce_rsce_navigation');

if (navigation){
    window.addEventListener('scroll',  ()=> {
        let scrollDepth = window.scrollY;

        if (scrollDepth > 100){
            navigation.classList.add('scrolled');
        } else {
            navigation.classList.remove('scrolled');
        }
    })
}